var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/1/rsts/svet-bydleni.cz/~/enquire.js/src/index.js
// module id = 9
// module chunks = 0